import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { path: "/", label: "首页" },
  { path: "/category/celebrity-gossip", label: "明星八卦" },
  { path: "/category/influencer-gossip", label: "网红爆料" },
  { path: "/category/variety-shows", label: "综艺热点" },
  { path: "/category/film-tv-news", label: "影视资讯" },
  { path: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2 shrink-0"
            aria-label="91EatGossip 首页"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-fire-fill text-white text-lg" />
            </div>
            <span
              className={`font-heading text-lg md:text-xl font-bold tracking-tight transition-colors ${
                scrolled ? "text-foreground-900" : "text-foreground-900"
              }`}
            >
              91EatGossip
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                  location.pathname === link.path
                    ? "text-primary-500"
                    : scrolled
                      ? "text-foreground-700"
                      : "text-foreground-800"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-900"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i
              className={`ri-${mobileOpen ? "close" : "menu"}-line text-xl`}
            />
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-3 px-3 text-sm font-medium rounded-md transition-colors ${
                  location.pathname === link.path
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}